<template>
  <confirm-modal
    ref="modal"
    title="Удаление доступа"
    confirm="Удалить"
    reset="Отменить"
    mode="danger"
    @confirm="confirm"
  >
    <span>
      Доступ <b>{{ name }}</b> будет удален без возможности восстановления.
    </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  components: { ConfirmModal },
  data() {
    return {
      id: null,
      name: "",
    };
  },
  methods: {
    open(access) {
      this.id = access.id;
      this.name = access.name;
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
      this.id = null;
      this.name = null;
    },
    confirm() {
      this.$store.dispatch("referenceIiko/removeAccess", { id: this.id }).then(() => {
        this.close();
        this.$nextTick(() => {
          this.$emit("remove", this.id);
        });
      });
    },
  },
};
</script>
